module.exports = __webpack_public_path__ + "static/media/r2.aacf28c8.png";